var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircleYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FFF8E2",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9653 21.0685V23.7352M22.9653 26.4018H22.972M21.8253 17.6418L16.1787 27.0685C16.0623 27.2701 16.0007 27.4987 16 27.7315C15.9994 27.9643 16.0597 28.1932 16.175 28.3955C16.2903 28.5978 16.4565 28.7663 16.6572 28.8844C16.8578 29.0025 17.0859 29.0659 17.3187 29.0685H28.612C28.8448 29.0659 29.0729 29.0025 29.2735 28.8844C29.4742 28.7663 29.6404 28.5978 29.7557 28.3955C29.871 28.1932 29.9313 27.9643 29.9307 27.7315C29.93 27.4987 29.8684 27.2701 29.752 27.0685L24.1053 17.6418C23.9865 17.4459 23.8192 17.2839 23.6195 17.1715C23.4198 17.0591 23.1945 17 22.9653 17C22.7362 17 22.5109 17.0591 22.3112 17.1715C22.1115 17.2839 21.9442 17.4459 21.8253 17.6418Z",
    stroke: "#DC6803",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircleYellow);
export default __webpack_public_path__ + "static/media/alert-circle-yellow.62cd6043fa8c7fda2a86cab844ae3d26.svg";
export { ForwardRef as ReactComponent };